function numberToString(value: number, { decimalDigits = 2 } = {}) {
  return parseFloat(value.toFixed(decimalDigits)).toString()
}

export { numberToString }
